// Copyright © 2021 Move Closer
/**
 * @author Sebastian Dziechciarz <sebastian.dziechciarz@movecloser.pl
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var BootstrapTheme;
(function (BootstrapTheme) {
    BootstrapTheme["Default"] = "default";
    BootstrapTheme["Danger"] = "danger";
    BootstrapTheme["Dark"] = "dark";
    BootstrapTheme["Info"] = "info";
    BootstrapTheme["Light"] = "light";
    BootstrapTheme["Primary"] = "primary";
    BootstrapTheme["Secondary"] = "secondary";
    BootstrapTheme["Success"] = "success";
    BootstrapTheme["Warning"] = "warning";
})(BootstrapTheme || (BootstrapTheme = {}));
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const bootstrapValidationClassRegistry = {
    invalid: 'is-invalid',
    valid: 'is-valid'
};
